import React from 'react'
import styles from './JobContent.module.css'
import { adaptOccupationData } from './occupationAdapter'
import { FormTitle } from '../../../Common/FormTitle'
import { CategorySelector } from '../../../Common/Pulldown/CategorySelector'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'

export const JobContent = () => {
    const { dataViewLabel } = useAbTestGtm()
    const occupationData = adaptOccupationData()

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollControll}>
                <div
                    className={styles.selectionWrapper}
                    data-view-label={dataViewLabel('EF_StepForm_仕事内容')}
                >
                    <div className={styles.monthbox}>
                        <FormTitle formTitleText='仕事内容はなんですか？' />
                    </div>
                    <CategorySelector
                        categoryData={occupationData}
                        formKey={['userResumesAttributes', 'occupationIds']}
                        displayFormKey={'occupation'}
                        idField='occupationIds'
                        searchPlaceholder='仕事内容を検索する'
                        clickLabelPrefix='EF_StepForm_仕事内容'
                    />
                </div>
            </div>
        </div>
    )
}
